import { useEffect, useRef } from 'react';
import { HotjarProps } from './types';
function Hotjar({
  hotjarId
}: HotjarProps) {
  const idRef = useRef(hotjarId);
  useEffect(() => {
    if (!idRef.current) return;
    window.hj = window.hj || (/** @type {typeof window.hj} */(...args) => (window.hj.q = window.hj.q || []).push(args));
    window._hjSettings = {
      hjid: idRef.current,
      hjsv: 6
    };
    const head = document.getElementsByTagName('head')[0];
    const hotjarScript = document.createElement('script');
    hotjarScript.async = true;
    hotjarScript.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
    head?.appendChild(hotjarScript);
  }, []);
  return null;
}
export default Hotjar;